import { initEventBus, MetaTrackEvent } from './eventBus';

const eventBus = initEventBus();

export const metaPixel = {
  /**
   * TT-289: ask the host to send a standard Meta event; the host owns the Pixel
   */
  track: (event: MetaTrackEvent['event'], eventId?: string) => {
    eventBus.emit('meta:track', eventId ? { event, eventId } : { event });
  },
};
